// src/hooks/useContatos.ts
import { useState, useEffect } from 'react';
import { apiService } from '../services/api';
import { Contato } from '../types/contato';

export const useContatos = () => {
  const [contatos, setContatos] = useState<Contato[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchContatos = async () => {
    try {
      setLoading(true);
      const response = await apiService.getContatos();
      setContatos(response.data || []);
      setError(null);
    } catch (err) {
      setError('Erro ao carregar contatos');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchContatos();
  }, []);

  return { contatos, loading, error, refetchContatos: fetchContatos };
};